export default function Game(){
    return (
        <div>
            The game started
        </div>
    )
}